var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('img',{staticClass:"bg-image",attrs:{"src":_vm.image,"alt":"QRCode-image"}}),_c('div',{staticClass:"bg-title"},[_vm._v(" 关注“宝来客”学习运营秘籍 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }